import type { ClientPropertyArtDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ArtFormFields } from "web_myplann/Portfolio/Forms/ArtForm/ArtFormFields";
import { useEditArtForm } from "web_myplann/Portfolio/Forms/ArtForm/useEditArtForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditArtFormProps = {
	propertyId: number;
	property: ClientPropertyArtDetailResponseDTO;
	detailRoute: string;
};

export const EditArtForm = ({
	propertyId,
	property,
	detailRoute,
}: EditArtFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } = useEditArtForm({
		propertyId,
		property,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditProperty.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<ArtFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
